// Header.js
import React from 'react';
import NestQuestROILogo from './NestQuestROILogo';

const Header = () => {
  return (
    <header className="bg-white shadow-md p-4 flex justify-center">
      <NestQuestROILogo />
    </header>
  );
};

export default Header;
